import * as ngCore from '@angular/core'

@ngCore.Component({
  selector: 'atn-ds-radio-option',
  standalone: true,
  styleUrls: ['./radio-option.component.scss'],
  templateUrl: './radio-option.component.html',
})
export class AtnDsRadioOptionComponent {
  public readonly nameSg = ngCore.input.required<string>({ alias: 'name' })

  public readonly isActiveSg = ngCore.input<boolean | undefined>(false, {
    alias: 'isActive',
  })
}
